"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formLabel = exports.formInput = exports.formHeader = exports.formCheckBoxYN = exports.YNOptions = exports.SimpleFormYearPicker = exports.SimpleFormTextEditor = exports.SimpleFormTextAreaWithError = exports.SimpleFormTextArea = exports.SimpleFormFieldArray = exports.SimpleFormDropdown = exports.SimpleFormDateTimePicker = exports.SimpleFormDateRangePicker = exports.SimpleFormDatePicker = exports.SimpleFormCheckboxYN = exports.SimpleFormCheckbox = exports.SimpleFormCheckBoxFromOptions = exports.FormInputWithHiddenField = void 0;
var React = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _semanticUiCalendarReact = require("semantic-ui-calendar-react");
var _reactFlexboxGrid = require("react-flexbox-grid");
var _formik = require("formik");
var _Simpleform = require("./Simpleform");
var _FormField = require("./FormField");
var _toDate = require("../utils/toDate");
var _Editor = _interopRequireDefault(require("../Editor"));
var _excluded = ["onChange"],
  _excluded2 = ["onChange"],
  _excluded3 = ["onChange"],
  _excluded4 = ["onChange"],
  _excluded5 = ["onChange", "dateTimeFormat"],
  _excluded6 = ["checked", "onChange"],
  _excluded7 = ["onChange", "label", "iconPosition"],
  _excluded8 = ["onChange", "label", "iconPosition"],
  _excluded9 = ["onChange", "label", "iconPosition"],
  _excluded10 = ["onChange"],
  _excluded11 = ["onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var SimpleFormDropdown = exports.SimpleFormDropdown = /*#__PURE__*/React.memo(function (props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({}, restProps, {
    control: function control(cprops) {
      return /*#__PURE__*/React.createElement(_semanticUiReact.Dropdown, _extends({}, cprops, {
        fluid: true,
        onChange: function onChange(e, _ref) {
          var value = _ref.value;
          props.setFieldValue(props.name, value);
        }
      }));
    }
  }));
});
var EditorComp = /*#__PURE__*/function (_React$Component) {
  function EditorComp() {
    var _this;
    _classCallCheck(this, EditorComp);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EditorComp, [].concat(args));
    _defineProperty(_this, "render", function () {
      return /*#__PURE__*/React.createElement(_Editor["default"], _extends({}, _this.props, {
        onChange: function onChange(html) {
          _this.props.setFieldValue(_this.props.name, html);
        }
      }));
    });
    return _this;
  }
  _inherits(EditorComp, _React$Component);
  return _createClass(EditorComp);
}(React.Component);
var SimpleFormTextEditor = exports.SimpleFormTextEditor = /*#__PURE__*/React.memo(function (props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({}, restProps, {
    control: EditorComp
  }));
}, function (prevProps, nextProps) {
  return prevProps.name == nextProps.name && prevProps.value === nextProps.value && prevProps.error === nextProps.error;
});
var TAComp = /*#__PURE__*/function (_React$Component2) {
  function TAComp() {
    var _this2;
    _classCallCheck(this, TAComp);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, TAComp, [].concat(args));
    _defineProperty(_this2, "render", function () {
      return /*#__PURE__*/React.createElement(_semanticUiReact.TextArea, _extends({}, _this2.props, {
        onChange: function onChange(e, _ref2) {
          var value = _ref2.value;
          _this2.props.setFieldValue(_this2.props.name, value);
        }
      }));
    });
    return _this2;
  }
  _inherits(TAComp, _React$Component2);
  return _createClass(TAComp);
}(React.Component);
var SimpleFormTextAreaWithError = exports.SimpleFormTextAreaWithError = /*#__PURE__*/React.memo(function (props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded3);
  var error = props.value && props.value.toString().length > 1300;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_FormField.FormField, _extends({}, restProps, {
    control: TAComp
  })), error ? /*#__PURE__*/React.createElement("div", {
    className: "errorArea"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Your text exceeds the character limit allowed (1300).")), " ") : /*#__PURE__*/React.createElement("div", {
    className: "errorArea"
  }, /*#__PURE__*/React.createElement("span", null, "\xA0")));
}, function (prevProps, nextProps) {
  return prevProps.name == nextProps.name && prevProps.value === nextProps.value;
});
var SimpleFormTextArea = exports.SimpleFormTextArea = /*#__PURE__*/React.memo(function (props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded4);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({}, restProps, {
    control: TAComp
  }));
}, function (prevProps, nextProps) {
  return prevProps.name == nextProps.name && prevProps.value === nextProps.value;
});
var SimpleFormDateTimePicker = exports.SimpleFormDateTimePicker = /*#__PURE__*/React.memo(function (props) {
  var onChange = props.onChange,
    dateTimeFormat = props.dateTimeFormat,
    restProps = _objectWithoutProperties(props, _excluded5);
  var formfieldProps = restProps;
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({}, formfieldProps, {
    control: function control(cprops) {
      var restProps = _extends({}, (_objectDestructuringEmpty(cprops), cprops));
      return /*#__PURE__*/React.createElement(_semanticUiCalendarReact.DateTimeInput, _extends({}, restProps, {
        value: (0, _toDate.toDate)(cprops.value),
        animation: "fade",
        dateFormat: "YYYY-MM-DD HH:mm",
        dateTimeFormat: "YYYY-MM-DD HH:mm",
        initialDate: undefined,
        onChange: function onChange(e, _ref3) {
          var value = _ref3.value;
          props.setFieldValue(props.name, value && value.length > 1 ? value.toLocaleString(undefined, {
            hour12: false
          }) : "");
          if (props.stringName && props.stringName.length > 1) {
            props.setFieldValue(props.stringName, value && value.length > 1 ? value.toLocaleString(undefined, {
              hour12: false
            }) + ":00" : "");
          }
        }
      }));
    }
  }));
}, function (prevProps, nextProps) {
  return prevProps.name == nextProps.name && prevProps.value === nextProps.value;
});
var FormInputWithHiddenField = exports.FormInputWithHiddenField = function FormInputWithHiddenField(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, props), props.className && props.className.includes("input-hidden") && /*#__PURE__*/React.createElement("span", {
    className: "hidden-value"
  }, props.value));
};
var SimpleFormCheckbox = exports.SimpleFormCheckbox = function SimpleFormCheckbox(props) {
  var checked = props.checked,
    onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/React.createElement(_semanticUiReact.Form.Checkbox, _extends({}, restProps, {
    checked: !!props.value,
    onChange: function onChange(e, _ref4) {
      var checked = _ref4.checked;
      props.setFieldValue(props.name, checked);
    }
  }));
};
var SimpleFormDatePicker = exports.SimpleFormDatePicker = function SimpleFormDatePicker(props) {
  var onChange = props.onChange,
    label = props.label,
    iconPosition = props.iconPosition,
    restProps = _objectWithoutProperties(props, _excluded7);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({
    label: label
  }, restProps, {
    control: function control(cprops) {
      return /*#__PURE__*/React.createElement(_semanticUiCalendarReact.DateInput, _extends({}, cprops, {
        value: cprops.value,
        timeZone: "undefined",
        localization: "en-GB",
        animation: "fade",
        iconPosition: iconPosition,
        onChange: function onChange(e, data) {
          props.setFieldValue(data.name, data.value);
          if (props.stringName && props.stringName.length > 1) {
            props.setFieldValue(props.stringName, data.value && data.value.length > 1 ? data.value : "");
          }
        }
      }));
    }
  }));
};
var SimpleFormYearPicker = exports.SimpleFormYearPicker = function SimpleFormYearPicker(props) {
  var onChange = props.onChange,
    label = props.label,
    iconPosition = props.iconPosition,
    restProps = _objectWithoutProperties(props, _excluded8);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({
    label: label
  }, restProps, {
    control: function control(cprops) {
      return /*#__PURE__*/React.createElement(_semanticUiCalendarReact.YearInput, _extends({}, cprops, {
        animation: "fade",
        iconPosition: iconPosition,
        onChange: function onChange(e, data) {
          if (data.value !== null && data.value !== undefined && data.value.toString().length > 3) {
            var pickedDate = new Date(data.value, 6, 6).getFullYear().toString();
            props.setFieldValue(data.name, pickedDate);
          } else {
            props.setFieldValue(data.name, null);
          }
        }
      }));
    }
  }));
};
var SimpleFormDateRangePicker = exports.SimpleFormDateRangePicker = function SimpleFormDateRangePicker(props) {
  var onChange = props.onChange,
    label = props.label,
    iconPosition = props.iconPosition,
    restProps = _objectWithoutProperties(props, _excluded9);
  return /*#__PURE__*/React.createElement(_FormField.FormField, _extends({
    label: label
  }, restProps, {
    control: function control(cprops) {
      return /*#__PURE__*/React.createElement(_semanticUiCalendarReact.DatesRangeInput, _extends({}, cprops, {
        animation: "fade",
        iconPosition: iconPosition,
        onChange: function onChange(e, _ref5) {
          var name = _ref5.name,
            value = _ref5.value;
          props.setFieldValue(name, value);
        }
      }));
    }
  }));
};
var SimpleFormCheckboxYN = exports.SimpleFormCheckboxYN = function SimpleFormCheckboxYN(props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded10);
  return props.options && props.options.map(function (option) {
    var componentNameValue = props.value;
    return /*#__PURE__*/React.createElement(_semanticUiReact.Radio, {
      disabled: props.disabled,
      readOnly: props.readOnly,
      key: props.name + option.key,
      label: option.text,
      onChange: function onChange() {
        props.setFieldValue(props.name, option.value);
      },
      checked: componentNameValue === option.value
    });
  });
};
var SimpleFormCheckBoxFromOptions = exports.SimpleFormCheckBoxFromOptions = function SimpleFormCheckBoxFromOptions(props) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded11);
  var checkedOptions = props.value || [];
  return props.options ? /*#__PURE__*/React.createElement(_reactFlexboxGrid.Row, null, props.options.map(function (option) {
    if (!option.value) {
      return null;
    }
    var isChecked = checkedOptions.includes(option.value.toString());
    return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Col, _extends({
      key: option.value + option.key
    }, option.colSize), /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
      disabled: props.disabled,
      readOnly: props.readOnly,
      name: "" + option.value,
      label: option.text,
      defaultChecked: isChecked,
      checked: isChecked,
      className: "checkbox-options",
      onChange: function onChange(e, _ref6) {
        var checked = _ref6.checked;
        if (checked) {
          option.value && props.setFieldValue(props.name, [].concat(_toConsumableArray(checkedOptions), [option.value.toString()]));
        } else {
          option.value && props.setFieldValue(props.name, checkedOptions.filter(function (op) {
            return option.value && op != option.value.toString();
          }));
        }
      }
    }));
  })) : null;
};
var YNOptions = exports.YNOptions = [{
  key: 1,
  text: "Yes",
  value: "y"
}, {
  key: 2,
  text: "No",
  value: "n"
}];
var formCheckBoxYN = exports.formCheckBoxYN = function formCheckBoxYN(name, colSizeLg, colSizeClassName, defaultValue) {
  return {
    component: _semanticUiReact.Form.Radio,
    props: {
      control: SimpleFormCheckboxYN,
      name: name,
      options: YNOptions,
      defaultValue: defaultValue
    },
    colSize: {
      lg: colSizeLg,
      className: colSizeClassName
    }
  };
};
var formInput = exports.formInput = function formInput(name, colSizeLg, colSizeClassName, placeholder, validation, defaultValue) {
  return {
    validation: validation,
    component: _semanticUiReact.Form.Input,
    props: {
      name: name,
      defaultValue: defaultValue,
      placeholder: placeholder || ""
    },
    colSize: {
      lg: colSizeLg,
      className: colSizeClassName
    }
  };
};
var SimpleFormFieldArray = exports.SimpleFormFieldArray = function SimpleFormFieldArray(props) {
  return /*#__PURE__*/React.createElement(_semanticUiReact.Segment, null, /*#__PURE__*/React.createElement(_formik.FieldArray, {
    name: props.name,
    render: function render(arrayHelper) {
      return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Row, null, /*#__PURE__*/React.createElement(React.Fragment, null, props.fields ? props.fields.map(function (field, index) {
        return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Col, _extends({
          key: index
        }, field.colSize), (0, _Simpleform.renderFormField)(field.component, props.disabled, props.readonly || field.props.readonly, field.props));
      }) : null), props.value && props.value.map(function (rowData, rowIndex) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, props.fieldArrayFields ? props.fieldArrayFields.map(function (field, index) {
          return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Col, _extends({
            key: index
          }, field.colSize), (0, _Simpleform.renderFormField)(field.component, props.disabled, props.readonly || field.props.readonly, _objectSpread(_objectSpread({}, field.props), {}, {
            value: rowData[field.props.name],
            // field.props || "",
            name: "".concat(props.name, ".").concat(rowIndex, ".").concat(field.props.name)
          }), undefined, undefined, rowData[field.props.name]));
        }) : null);
      }), !props.disabled && !props.readonly && /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
        type: "button",
        content: "add Row",
        onClick: function onClick() {
          arrayHelper.push({});
        }
      }));
    }
  }));
};
var formLabel = exports.formLabel = function formLabel(labelName, content, labelLg, labelClassName, defaultValue) {
  return {
    component: _semanticUiReact.Label,
    props: {
      name: labelName,
      content: content,
      defaultValue: defaultValue
    },
    colSize: {
      lg: labelLg,
      className: labelClassName
    }
  };
};
var formHeader = exports.formHeader = function formHeader(name, content, size, className, colSizeLG, colSizeClassName, defaultValue) {
  return {
    component: _semanticUiReact.Header,
    props: {
      name: name,
      size: size,
      className: className,
      content: content,
      defaultValue: defaultValue
    },
    colSize: {
      lg: colSizeLG,
      className: colSizeClassName
    }
  };
};